<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn v-bind="props" class="font-weight-bold mt-4 ml-4 mb-2">
          Acessar Area de Concentração
        </v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5"
              >Visualizar Bugs da Area de Concentração: {{ descricao }}</span
            >
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-table
          class="ma-8 req--table"
          style="background: transparent"
          fixed-header="true"
          density="comfortable"
        >
          <thead class="text-grey">
            <tr>
              <th class="rounded-ts-lg text-center text-grey">#</th>
              <th
                style="border-left: thin solid #efefef"
                class="text-center text-grey"
              >
                Bug
              </th>
              <th
                style="border-left: thin solid #efefef"
                class="rounded-te-lg text-center text-grey"
              >
                Observação
              </th>
              <th
                style="border-left: thin solid #efefef"
                class="rounded-te-lg text-center text-grey"
              >
                Status
              </th>
              <th
                style="border-left: thin solid #efefef"
                class="rounded-te-lg text-center text-grey"
              >
                Tipo
              </th>
              <th
                style="border-left: thin solid #efefef"
                class="rounded-te-lg text-center text-grey"
              >
                Gravidade
              </th>
            </tr>
          </thead>
          <div class="split"></div>

          <tbody>
            <tr v-for="item in bugs" :key="item" color="#90EE90">
              <td class="text-center">
                {{ item.id_bug }}
              </td>

              <td style="border-left: thin solid #efefef" class="text-center">
                <RouterLink
                  :to="'/projects/' + this.idProjeto + '/Bugs/' + item.id_bug"
                >
                  {{ item.descricao }}
                </RouterLink>
              </td>

              <td style="border-left: thin solid #efefef" class="text-center">
                {{ item.observacao }}
              </td>

              <td style="border-left: thin solid #efefef" class="text-center">
                {{ item.status_bug }}
              </td>

              <td style="border-left: thin solid #efefef" class="text-center">
                {{ item.tipo_bug }}
              </td>

              <td style="border-left: thin solid #efefef" class="text-center">
                {{ item.gravidade }}
              </td>
            </tr>

            <tr>
              <td class="pl-10 text-left"></td>
              <td class="text-grey text-body-2 text-left">
                <ModalCriarBug
                  v-if="isQA"
                  @bug-criado="getBugs"
                  :id="id"
                  :index="index"
                  :csu="csu"
                />
              </td>
              <td class="text-center"></td>
              <td class="text-left"></td>
              <td class="text-left"></td>
            </tr>
          </tbody>
        </v-table>
      </v-card>

      <v-container
        v-if="this.isLoading"
        class="d-flex justify-center align-center"
      >
        <v-progress-circular class="text-center" indeterminate size="20" />
      </v-container>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 * @module AreaConcentracaoBugs
 * @desc Modal que lista os bugs da área de concentração.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o modal está visível.
 * @vue-data {Array.<Object>} [bugs=[]] - Array com os bugs da área de
 * concentração.
 * @vue-data {string} idProjeto - O id do projeto.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se os bugs ainda
 * estão sendo carregados.
 * @vue-computed {boolean} isQA - Flag que indica se o usuário atual é um
 * testador.
 */
import axios from 'axios';

import ModalCriarBug from '@/components/dialogs/AreaConcentracaoCriarBug.vue';
import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    index: Number,
    csu: Object,
    descricao: String,
  },
  components: {
    ModalCriarBug,
  },
  data() {
    return {
      dialog: false,
      bugs: [],
      idProjeto: this.$route.params.idProjeto,
      isLoading: false,
    };
  },
  mounted() {
    this.getBugs(this.id);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  computed: {
    isQA() {
      return localStorage.getItem('formaAtuacao') === '"TESTADOR"';
    },
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para obter os bugs da área de concentração.
     *
     * @param {Number} id O id da área de concentração.
     */
    async getBugs(id) {
      this.isLoading = true;
      axios
        .get(apiUrl + `/api/v1/bug/areaConcentracao/${id}`, {
          headers: {
            Authorization: 'Bearer ' + store.state.token,
          },
        })
        .then((res) => {
          this.isLoading = false;
          this.bugs = res.data.bugs;
        })
        .catch((error) => console.log(error));
    },
  },
};

// #EFEFEF
// #F9F8F8
// #B6B6B6
// #004984
</script>

<style>
.usecase--table .split {
  background-color: #f9f8f8;
  height: 1rem;
}

.usecase--table tbody tr {
  background-color: #fff;
}

.usecase--table a {
  text-decoration: none;
  color: black;
}

/* th:first-child {
    border-top-left-radius: 12px;
  }
  th:last-child {
    border-top-right-radius: 12px;
  } */
</style>
